import { AfterContentInit, Component, ContentChildren, Input, OnChanges, QueryList, SimpleChanges, ViewChild } from '@angular/core';
import { CheckboxComponent } from '../checkbox/checkbox.component';

@Component({
    selector: 'tvcore-checkbox-list',
    templateUrl: './checkbox-list.component.html',
    styleUrls: ['./checkbox-list.component.scss'],
    standalone: false
})
export class CheckboxListComponent implements AfterContentInit, OnChanges {
	@Input()
	amount: number = 0;
	@Input()
	disabled: boolean = false;
	@Input()
	title: string;
	@Input()
	LABEL_LESS: string;
	@Input()
	LABEL_MORE: string;

	@ContentChildren(CheckboxComponent)
	checkboxes: QueryList<CheckboxComponent>;
	@ViewChild('listContent')
	listContent: any;

	fullHeight: string;
	minHeight: string;
	showAll: boolean = false;
	showLimiter: boolean = false;

	ngAfterContentInit() {
		setTimeout(() => {
			this.showLimiter = this.amount > 0 && this.amount < this.checkboxes.length;

			if (this.showLimiter) {
				const height = this.listContent?.nativeElement.scrollHeight;
				this.fullHeight = `${height}px`;

				const margin = 16;
				this.minHeight = `${((height - margin) / this.checkboxes.length) * this.amount + margin}px`;
			} else {
				this.fullHeight = 'auto';
			}
		}, 200);
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['disabled'] && changes['disabled'].previousValue === false && changes['disabled'].currentValue === true) {
			this.showAll = false;
			this.checkboxes.forEach((checkbox) => checkbox.control?.setValue(false));
		}
	}

	toggle() {
		this.showAll = !this.showAll;
	}
}
